import React, { Fragment } from 'react';
import { Section } from '../ui/Section';
import { Gift, Plus } from 'lucide-react';
import { motion } from 'framer-motion';
export function Bonuses() {
  const bonuses = [{
    image: 'https://cdn.magicpatterns.com/uploads/bEdJ2M3TfAdF74m5CjqSKS/bono_1_(2).png',
    title: 'Mapa Antiestrés Financiero',
    description: 'No estás sola. Tenés un plan.'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/mCzxJKKBmQ4bHnm8dnJfa3/bono_2.png',
    title: 'Qué hacer cuando sentís que no llegás',
    description: 'Menos ansiedad · Más claridad · Calma inmediata'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/eTG1RSUYHiv4XXy5wcu8Wj/bono_3.png',
    title: 'Planificador financiero editable + versión imprimible',
    description: 'Versión digital para editar + Versión lista para imprimir'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/mehUEaxhzyGEf9F3WscDBy/bono_4.png',
    title: 'Checklist imprimible: salí del desorden',
    description: 'Algo listo para avanzar ahora · Sin vueltas · Sin caos mental · Orden inmediata'
  }];
  return <Section background="gradient-pink" className="text-center" data-id="element-30">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6
    }} data-id="element-31">
        <div className="inline-flex items-center gap-2 bg-gradient-to-r from-fuchsia-500 to-pink-500 text-white px-6 py-2 rounded-full text-sm font-black mb-8 shadow-lg animate-pulse" data-id="element-32">
          <Gift className="w-5 h-5" data-id="element-33" />
          GRATIS HOY
        </div>

        <h2 className="text-4xl md:text-5xl font-black text-slate-900 mb-4" data-id="element-34">
          Bonos incluidos{' '}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-fuchsia-600 to-pink-600" data-id="element-35">
            hoy
          </span>
        </h2>

        <p className="text-xl text-slate-700 mb-12" data-id="element-36">Sin costo adicional</p>

        <div className="max-w-6xl mx-auto space-y-6" data-id="element-37">
          {bonuses.map((bonus, index) => <Fragment key={index} data-id="element-38">
              <motion.a href="#purchase-section" className="block group cursor-pointer" initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: index * 0.1
          }} viewport={{
            once: true
          }} whileHover={{
            scale: 1.02
          }} data-id="element-39">
                <div className="bg-white p-6 md:p-8 rounded-2xl border-4 border-fuchsia-200 group-hover:border-fuchsia-400 transition-all shadow-xl relative overflow-hidden" data-id="element-40">
                  <div className="absolute -top-3 -right-3 bg-gradient-to-r from-fuchsia-500 to-pink-500 text-white text-xs font-black px-4 py-2 rounded-full shadow-lg z-10" data-id="element-41">
                    BONO #{index + 1}
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center" data-id="element-42">
                    <div className="relative" data-id="element-43">
                      <div className="absolute inset-0 bg-gradient-to-br from-fuchsia-200/30 to-pink-200/30 rounded-xl blur-xl" data-id="element-44"></div>
                      <img src={bonus.image} alt={bonus.title} className="relative rounded-xl shadow-lg w-full object-cover border-2 border-fuchsia-100" data-id="element-45" />
                    </div>
                    <div className="text-left" data-id="element-46">
                      <h3 className="text-2xl md:text-3xl font-black text-slate-900 mb-4" data-id="element-47">
                        {bonus.title}
                      </h3>
                      <p className="text-lg text-slate-700" data-id="element-48">
                        {bonus.description}
                      </p>
                    </div>
                  </div>
                </div>
              </motion.a>

              {index < bonuses.length - 1 && <div className="flex justify-center py-4" data-id="element-49">
                  <Plus className="w-10 h-10 text-fuchsia-500" strokeWidth={3} data-id="element-50" />
                </div>}
            </Fragment>)}
        </div>

        <motion.p className="mt-12 text-2xl font-black text-transparent bg-clip-text bg-gradient-to-r from-fuchsia-600 to-pink-600" animate={{
        scale: [1, 1.05, 1]
      }} transition={{
        duration: 2,
        repeat: Infinity
      }} data-id="element-51">
          Todo esto, GRATIS al comprar hoy
        </motion.p>
      </motion.div>
    </Section>;
}